import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // To navigate after logout
import { useAuth } from '../components/AuthContext'; // Use the AuthContext

const Logout = () => {
  const { logout } = useAuth(); // Get the logout function from the AuthContext
  const navigate = useNavigate(); // Get the navigate function to redirect

  useEffect(() => {
    const performLogout = async () => {
      await logout(); // Perform the logout
      navigate('/adminlogin'); // Redirect to the login page after logout
    };

    performLogout(); // Call the logout function
  }, [logout, navigate]);

  return (
    <div className="text-center mt-5">
      <h3>Logging out...</h3>
    </div>
  );
};

export default Logout;
